import { render, staticRenderFns } from "./ExpiredApp.vue?vue&type=template&id=c8862352&scoped=true&"
import script from "./ExpiredApp.vue?vue&type=script&lang=js&"
export * from "./ExpiredApp.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredApp.vue?vue&type=style&index=0&id=c8862352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8862352",
  null
  
)

export default component.exports